export function changeLoading(loading) {
	return {
		type: "@register/CHANGE_LOADING",
		payload: {
			loading,
		},
	};
}

export function onboardingGogogoRequest(password, isTermAccepted, event, tokenRecaptchaRegister, adid) {
	return {
		type: "@register/ONBOARDING_GOGOGO_REQUEST",
		payload: { password, isTermAccepted, event, tokenRecaptchaRegister, adid },
	};
}

export function onboardingGogogoRequestStep(password, isTermAccepted, isEduca = false) {
	return {
		type: "@register/ONBOARDING_GOGOGO_REQUEST_STEP",
		payload: { password, isTermAccepted, isEduca },
	};
}

export function updateOnboardFieldRequest(field, _value, extra, is_edition) {
	return {
		type: "@register/UPDATE_ONBOARD_FIELD_REQUEST",
		payload: { field, _value, extra, is_edition },
	};
}

export function onboardValidatingEmailResponse(resp) {
	return {
		type: "@register/ONBOARD_VALIDATING_EMAIL_RESPONSE",
		payload: { resp },
	};
}

export function updateChecoutRegisterFieldRequest(field, value, extra) {
	return {
		type: "@register/UPDATE_CHECKOUT_REGISTER_FIELD_REQUEST",
		payload: { field, value, extra },
	};
}

export function newInvestorRequest(info) {
	return {
		type: "@register/ONBOARDING_NEW_INVESTOR",
		payload: { info },
	};
}

export function changeCreatedStatus(status) {
	return {
		type: "@register/ONBOARDING_NEW_INVESTOR_STATUS",
		payload: { status },
	};
}

export function verifyDuplicityEmailRequest(email, cpfInvestor) {
	return {
		type: "@register/VALIDATING_EMAIL",
		payload: {
			email,
			cpfInvestor,
		},
	};
}

export function verifyDuplicityEmailResp(resp) {
	return {
		type: "@register/VALIDATING_EMAIL_RESP",
		payload: { resp },
	};
}

export function acceptedTerms(isTermAccepted) {
	return {
		type: "@register/ACCEPTED_TERMS",
		payload: { isTermAccepted },
	};
}

export function setVerificatedEmailDuplicity(result) {
	return {
		type: "@register/SET_VERIFICATED_EMAIL_DUPLICITY",
		payload: { result },
	};
}

export function initialOnboarding() {
	return {
		type: "@register/INITIAL_ONBOARDING",
		payload: {},
	};
}

export function validateInitialOnboarding(cd_access_token, header) {
	return {
		type: "@register/VALIDATE_INITIAL_ONBOARDING",
		payload: { cd_access_token, header },
	};
}

export function getResponseUpdateOnboardField(param) {
	return {
		type: "@register/GET_RESPONSE_UPDATE_ONBOARD_FIELD",
		payload: { param },
	};
}

export function loginByOnboardGogogoRequest(password, event = null, tokenRecaptchaRegister) {
	return {
		type: "@register/LOGIN_BY_ONBOARD_GOGOGO",
		payload: { password, event, tokenRecaptchaRegister },
	};
}

export function sendingToMarket(param) {
	return {
		type: "@register/SENDING_TO_MARKET",
		payload: { param },
	};
}

export function updateOnboardFieldsRequest(fields) {
	return {
		type: "@register/UPDATE_ONBOARD_FIELDS_REQUEST",
		payload: { fields },
	};
}

export function updatedAllFields(updated_all_fields) {
	return {
		type: "@register/UPDATED_ALL_FIELDS",
		payload: { updated_all_fields },
	};
}

export function sendTicket(payload) {
	return {
		type: "@register/TICKET_ZENDESK_REQUEST",
		payload,
	};
}

export function responseTicket(payload) {
	return {
		type: "@register/TICKET_ZENDESK_RESPONSE",
		payload,
	};
}

export function sendTicketLoading(payload) {
	return {
		type: "@register/SEND_TICKET_LOADING",
		payload,
	};
}
